'use client'

import Link from 'next/link'
import { Support } from 'shared/common/Footer/components/Support/Desktop/Support'

import styles from './HeaderTop.module.scss'

// TODO:  пока просто ссылки внутри прилки, возможно это будут внешние ссылки, оставил пока так

export function DesktopHeaderTop() {
  return (
    <>
      <div className={styles.headerTop}>
        <p>Доставляем каждый день с 09:00 до 21:00</p>
        <div className={styles.links}>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            passHref
            href={'https://mbank.kg/en/market?type=sellers'}
          >
            Market для бизнеса
          </Link>
          <Support label="Поддержка" />
        </div>
      </div>
    </>
  )
}
